/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { Box, Center, Button, Title, Space, Group, Text, Stack, Image } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { showNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons';
import { sendRequest } from '../../services/services';
import Qr from '../../image/qr-green.png';

import PrimaryButton from '../../components/GroupButton';

const Home = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  const [ticketNumber, setTicketNumber] = useState(null);

  const [barcodeRead, setBarcodeRead] = useState('');

  const barcode = {
    timing: 1000,
    data: '',
  };

  const barcodeReaded = () => {
    if (barcode.data.length > 1) {
      setBarcodeRead(barcode.data);
    } else {
      barcode.data = '';
    }
  };

  let timeout = setTimeout(barcodeReaded, 500);

  useEffect(() => {
    window.addEventListener('keypress', (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 1000) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReaded, 500);
      } else {
        barcode.data = '';
      }
    });
  }, []);

  useEffect(() => {
    const urlValue = barcodeRead;
    const arrayString = urlValue?.split('/home');
    const targetValue = arrayString[arrayString?.length - 1];
    const ticketValue = targetValue.slice(37);
    setTicketNumber(ticketValue);
    if (ticketNumber) {
      sendRequest(`parking/site-id-by-pass-id/${ticketNumber}`, 'get').then((data) => {
        if (data?.data?.site_id === siteDetails?.siteId) {
          sendRequest(`parking/reservations-by-pass-id/${ticketNumber}`, 'get').then((res) => {
            if (res?.code === 20) {
              navigate({
                pathname: '/addVas',
                search: createSearchParams({
                  passId: ticketNumber,
                }).toString(),
              });
            } else if (res?.code === 21) {
              showNotification({
                title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
                icon: <IconX size={16} />,
              });
            }
          });
        } else if (data?.data?.site_id !== siteDetails?.siteId) {
          showNotification({
            title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
            icon: <IconX size={16} />,
          });
        }
      });
    }
  }, [barcodeRead, ticketNumber]);

  return (
    <Box>
      {/* <TimerEvent /> */}
      <Center>
        <Stack>
          <Center>
            <Stack>
              <Center>
                <Title style={{ color: '#F9D923' }} order={1}>
                  {t('scan.qr.code.title.text')}
                </Title>
              </Center>
            </Stack>
          </Center>

          <Space h="md" />

          <Center>
            <Stack>
              <Center>
                <Image src={Qr} py="xl" style={{ width: '40%' }} />
              </Center>
              <Title order={3} sx={{ color: '#01AA84' }} py="xl">
                {t('enter.please.scan.qr.code')}
              </Title>
              {/* <div className="App"></div> */}
              {/* <Input
            ref={focusTrapRef}
            placeholder="Ticket Number"
            width="100%"
            onChange={onKeyPressBarcode}
          /> */}
              {/* {!ticketData?.data?.result?.id && ticketNumber ? ( */}
              {/* // <input type="text" id="one" onKeyPress={handleKeyPress} /> */}
              {/* <Input
            ref={focusTrapRef}
            placeholder="Ticket Number"
            width="100%"
            onChange={searchTicket}
            // onKeyPress={handleKeyPress}
          /> */}
              {/* ) : null} */}
              {/* {ticketData?.data?.result?.id === undefined  ? (
                <Title order={3}>{t('enter.invalid.qr.code')}</Title>
              ) : null} */}
            </Stack>
          </Center>
          <Center py="md">
            <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
              <Button onClick={() => navigate('/numberplate')} color="blue" size="xl">
                {t('enter.number.plate.button.text')}
              </Button>
              <Button onClick={() => navigate('/ticketnumber')} color="blue" size="xl">
                {t('enter.ticket.number.button.text')}
              </Button>
            </Group>
          </Center>
        </Stack>
      </Center>
      <Space h="xl" />
      <PrimaryButton />
      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
    </Box>
  );
};

export default Home;
